/* eslint-disable */

import { ReportType } from '@/shared/api/protocol-ts/model/dto_report_pb';
import {
  AnalyticsData,
  AnalyticsEventName,
  AnalyticsEventProperties,
  CLUSTER,
  ENVIRONMENT,
} from '../config';
import { trackPosthogEvent } from './posthogAnalytics';

let getAnalyticsData: (() => AnalyticsData) | null = null;

const pageViewEventCache = new Map<string, boolean>();

let currentUrl = window.location.pathname + window.location.search;

export const initializeAnalytics = (dataGetter: () => AnalyticsData) => {
  getAnalyticsData = dataGetter;
};

const getAnalyticsReportType = (reportType: ReportType) => {
  switch (reportType) {
    case ReportType.ReportType_CBCT_Endo:
      return 'CBCT_Endo';
    case ReportType.ReportType_CBCT_GP:
      return 'CBCT_GP';
    case ReportType.ReportType_CBCT_IOS_Superimposition:
      return 'CBCT_IOS_Superimposition';
    case ReportType.ReportType_CBCT_Molar:
      return 'CBCT_Molar';
    case ReportType.ReportType_CBCT_OrthoSlides:
      return 'CBCT_OrthoSlides';
    case ReportType.ReportType_CBCT_Segmentation:
      return 'CBCT_Segmentation';
    case ReportType.ReportType_DentalPhoto_GP:
      return 'DentalPhoto_GP';
    case ReportType.ReportType_IOS_Segmentation:
      return 'IOS_Segmentation';
    case ReportType.ReportType_IOXRay_GP:
      return 'IOXRay_GP';
    case ReportType.ReportType_InvalidValue:
      return 'InvalidValue';
    case ReportType.ReportType_Pano_Bitewings:
      return 'Pano_Bitewings';
    case ReportType.ReportType_CBCT_Implant:
      return 'CBCT_Implant';
    case ReportType.ReportType_Pano_GP:
      return 'Pano_GP';
    case ReportType.ReportType_StudioImplant:
      return 'StudioImplant';
    case ReportType.ReportType_StudioOrtho:
      return 'StudioOrtho';
    default:
      return 'undefined';
  }
};

const trackEvent = ({
  eventName,
  properties = {},
  isPageViewEvent,
}: {
  eventName: AnalyticsEventName;
  properties?: Partial<AnalyticsEventProperties>;
  isPageViewEvent?: boolean;
}): void => {
  const location = window.location;

  if (isPageViewEvent) {
    const newUrl = location.pathname + location.search;

    if (newUrl !== currentUrl) {
      currentUrl = newUrl;

      pageViewEventCache.clear();
    }

    if (pageViewEventCache.has(eventName)) {
      return;
    }

    pageViewEventCache.set(eventName, true);
  }

  const hostname = location.hostname;

  // NOTE: analyticsData might not arrive immediately, so to track page view events, we pass them separately from the page as a function parameter. For click events, we get the data from here
  const analyticsData = getAnalyticsData ? getAnalyticsData() : {};
  const { patientID, reportID, reportType, userID, email, organizationID } =
    analyticsData;

  const { report_type: propertyReportType, ...restProperties } = properties;

  const defaultProperties = {
    cluster: CLUSTER === 'oceania' ? 'au' : CLUSTER,
    hostname,
    env: ENVIRONMENT,
    ...(patientID && { patient_id: patientID }),
    ...(reportID && { report_id: reportID }),
    ...(reportType && { report_type: getAnalyticsReportType(reportType) }),
    ...(userID && { user_id: userID }),
    ...(email && { email }),
    ...(organizationID && { organization_id: organizationID }),
  };

  const finalProperties = {
    ...defaultProperties,
    ...restProperties,
    ...(propertyReportType !== undefined && {
      report_type: getAnalyticsReportType(propertyReportType),
    }),
  };

  trackPosthogEvent(eventName, finalProperties);
};

export { trackEvent };

/* eslint-enable */
